export default "__VITE_ASSET__CfhEs9rC__"